/**
 * Trikalbiai vertimai: lietuvių (lt), anglų (en), vokiečių (de).
 * Naudoti per useLanguage().t('key') arba t('key').
 */
export const translations = {
  lt: {
    // Bendri
    loading: 'Kraunama...',
    submit: 'Pateikti',
    cancel: 'Atšaukti',
    save: 'Išsaugoti',
    delete: 'Ištrinti',
    edit: 'Redaguoti',
    back: 'Atgal',
    next: 'Toliau',
    close: 'Uždaryti',
    search: 'Ieškoti',
    noResults: 'Rezultatų nerasta',
    error: 'Klaida',
    success: 'Sėkmingai',

    // Header / navigacija
    menu: 'Meniu',
    home: 'Pradžia',
    products: 'Produktai',
    cart: 'Krepšelis',
    myAccount: 'Mano paskyra',
    myOrders: 'Mano užsakymai',
    myFavorites: 'Mėgstamos prekės',
    login: 'Prisijungti',
    logout: 'Atsijungti',
    admin: 'Administravimas',
    accessibility: 'Prieinamumo nustatymai',
    openAccessibility: 'Atidaryti prieinamumo nustatymus',

    // Puslapiai
    pageNotFound: 'Puslapis nerastas',
    checkUrl: 'Prašome patikrinti URL adresą.',
    pageContent: 'Puslapio turinys',

    // Krepšelis
    yourCart: 'Jūsų prekių krepšelis',
    emptyCart: 'Jūsų krepšelis tuščias',
    emptyCartHint: 'Pridėkite prekių į krepšelį, kad pradėtumėte apsipirkimą.',
    continueShopping: 'Tęsti apsipirkimą',
    checkout: 'Pirkti',
    quantity: 'Kiekis',
    price: 'Kaina',
    total: 'Suma',
    remove: 'Pašalinti',

    // Produktai
    product: 'Prekė',
    addToCart: 'Į krepšelį',
    outOfStock: 'Išparduota',
    sale: 'Išpardavimas',
    qualityGoods: 'Kokybiškos prekės',
    bestGoods: 'Geriausios prekės už gerą kainą',
    viewAll: 'Peržiūrėti viską',

    // Užsakymai
    orders: 'Užsakymai',
    orderNumber: 'Užsakymo nr.',
    orderDate: 'Data',
    orderStatus: 'Statusas',
    viewOrder: 'Peržiūrėti užsakymą',
    payNow: 'Mokėti',
    redirectingToPayment: 'Nukreipiama į mokėjimą...',
    paymentSessionError: 'Nepavyko pradėti mokėjimo. Bandykite vėliau.',

    // Paskyra / auth
    register: 'Registruotis',
    forgotPassword: 'Pamiršote slaptažodį?',
    email: 'El. paštas',
    password: 'Slaptažodis',
    confirmPassword: 'Pakartokite slaptažodį',
    firstName: 'Vardas',
    lastName: 'Pavardė',
    phone: 'Telefonas',

    // Kontaktai
    contact: 'Kontaktai',
    contactSales: 'Susisiekti su pardavimais',
    cookies: 'Slapukai',

    // Kalbos
    language: 'Kalba',
    lang_lt: 'LT',
    lang_en: 'EN',
    lang_de: 'DE',

    // Home
    shopNow: 'Peržiūrėti dabar',
    quality: 'Kokybė',
    qualityText: 'Rinkitės tik kokybiškas prekes, kurios tarnaus ilgai ir patikimai. Kiekviena prekė atrenkama atsižvelgiant į aukščiausius standartus.',
    fastDelivery: 'Greitas pristatymas',
    fastDeliveryText: 'Greitai ir saugiai pristatome jūsų užsakymus visoje Lietuvoje. Patikimas pristatymas tiesiai į jūsų namus.',
    greatService: 'Puikus aptarnavimas',
    greatServiceText: 'Mūsų komanda visada pasiruošusi padėti ir atsakyti į jūsų klausimus. Profesionalus aptarnavimas kiekvienam klientui.',
    discoverMore: 'Atraskite daugiau',
    discoverMoreText: 'Magtic yra parduotuvė, kuri siūlo kokybiškas prekes už gerą kainą. Mūsų misija - suteikti jums geriausią pasirinkimą ir patirtį.',
    viewFullRange: 'Peržiūrėti visą asortimentą',
    testimonialQuote: 'Puikus pasirinkimas prekių ir greitas pristatymas. Labai patenkintas pirkiniu!',
    regularCustomer: 'Nuolatinis klientas',
    newLevel: 'Naujas lygis',
    newLevelText: 'Atraskite kokybiškas prekes, kurios pagerins jūsų kasdienybę. Rinkitės iš plataus asortimento ir mėgaukitės puikiu aptarnavimu.',
    viewMore: 'Peržiūrėti daugiau',
    allProducts: 'Visos prekės',

    // Products
    category: 'Kategorija',
    allCategories: 'Visos kategorijos',
    sortBy: 'Rūšiuoti',
    sortProducts: 'Rūšiuoti produktus',
    filterByCategory: 'Filtruoti pagal kategoriją',
    newest: 'Naujausi',
    nameAz: 'Pavadinimas A–Ž',
    nameZa: 'Pavadinimas Ž–A',
    priceAsc: 'Kaina didėjančiai',
    priceDesc: 'Kaina mažėjančiai',
    searchProducts: 'Ieškoti produktų',
    addedToCart: 'Prekė pridėta į krepšelį',
    errorAddingToCart: 'Klaida pridedant prekę',
    loadMore: 'Kraunama daugiau...',

    // Product detail
    variant: 'Variantas',
    addToFavorites: 'Į mėgstamus',
    removeFromFavorites: 'Iš mėgstamų',
    description: 'Aprašymas',
    specifications: 'Specifikacijos',
    sku: 'SKU',
    barcode: 'Brūkšninis kodas',
    packageDimensions: 'Pakuotės matmenys',
    packageSize: 'Siuntos dydis',
    youMayAlsoLike: 'Jums gali patikti',
    productNotFound: 'Produktas nerastas',
    noImage: 'Nėra nuotraukos',
    addedToFavorites: 'Prekė pridėta į mėgstamus',
    removedFromFavorites: 'Prekė pašalinta iš mėgstamų',
    loginRequiredFavorites: 'Norėdami naudoti mėgstamų prekių funkciją, turite prisijungti',
    sending: 'Siunčiama...',
    forgotPasswordSuccess: 'Jei toks el. paštas egzistuoja, išsiuntėme slaptažodžio atkūrimo nuorodą. Patikrinkite savo el. paštą.',
    tryAgainLater: 'Klaida. Bandykite vėliau.',
    backToLogin: 'Grįžti į prisijungimą',
    selectedVariant: 'Pasirinktas variantas',
    selected: 'Pasirinktas',
    inStock: 'Yra sandėlyje',
    outOfStockLabel: 'Nėra sandėlyje',
    adding: 'Pridedama...',
    saleEnds: 'Akcija baigiasi',
    recommended: 'Rekomenduojame',
    reviews: 'Atsiliepimai',
    collections: 'Kolekcijos',
    video: 'Video',
    stockQuantity: 'Atsargos',
    productIncludes: 'Šis produktas apima',
    bundleQuantity: 'Kiekis',
    bundleDiscount: 'Nuolaida',
    reviewsCount: '{n} atsiliepimų',
    backToProducts: '← Visos prekės',
    selectSize: 'Pasirinkite dydį',
    sizeGuide: 'Dydžių lentelė',
    averageRating: 'Vidutinis įvertinimas',
    outOfFive: 'iš 5',

    // Checkout
    checkoutTitle: 'Užsakymo formavimas',
    checkoutSubtitle: 'Užpildykite informaciją ir pateikite užsakymą',
    billingAddress: 'Atsiskaitymo adresas',
    selectSavedAddresses: 'Pasirinkti iš išsaugotų adresų',
    enterNewAddress: 'Įvesti naują adresą',
    selectBillingAddress: 'Pasirinkite atsiskaitymo adresą',
    selectAddress: 'Pasirinkite adresą...',
    defaultAddress: 'Numatytasis',
    company: 'Įmonė',
    address: 'Adresas',
    addressExtra: 'Papildoma informacija',
    city: 'Miestas',
    postalCode: 'Pašto kodas',
    country: 'Šalis',
    shippingAddress: 'Pristatymo adresas',
    sameAsBilling: 'Tas pats kaip atsiskaitymo',
    shippingSameAsBilling: 'Pristatymo adresas toks pat kaip atsiskaitymo',
    deliveryMethod: 'Pristatymo būdas',
    selectDelivery: 'Pasirinkite pristatymo būdą',
    paymentMethod: 'Mokėjimo būdas',
    selectPayment: 'Pasirinkite mokėjimo būdą',
    orderNotes: 'Užsakymo pastabos',
    placeOrder: 'Pateikti užsakymą',
    cartEmpty: 'Krepšelis tuščias',
    chooseShipping: 'Pasirinkite pristatymo būdą',
    choosePayment: 'Pasirinkite mokėjimo būdą',

    // Auth
    loginTitle: 'Prisijungti',
    loginSubtitle: 'Įveskite el. paštą ir slaptažodį',
    registerSubtitle: 'Sukurkite paskyrą',
    toHome: 'Į pradžią',
    loginError: 'Prisijungimo klaida',
    loggedOutDueToInactivity: 'Jūs buvote atsijungti dėl neaktyvumo (daugiau nei 2 val.). Prisijunkite dar kartą.',
    or: 'arba',
    noAccount: 'Neturite paskyros?',
    forgotPasswordLink: 'Pamiršau slaptažodį',
    forgotPasswordTitle: 'Slaptažodžio atkūrimas',
    forgotPasswordSubtitle: 'Įveskite el. paštą ir išsiųsime atkūrimo nuorodą',
    sendResetLink: 'Siųsti nuorodą',
    resetPasswordTitle: 'Nustatyti naują slaptažodį',
    newPassword: 'Naujas slaptažodis',
    resetPassword: 'Atkurti slaptažodį',
    passwordRequirements: 'Slaptažodžio reikalavimai',
    minChars: 'Mažiausiai 8 simboliai',
    oneUpperCase: 'Bent viena didžioji raidė',
    oneLowerCase: 'Bent viena mažoji raidė',
    oneNumber: 'Bent vienas skaičius',
    oneSymbol: 'Bent vienas specialus simbolis',
    passwordMismatch: 'Slaptažodžiai nesutampa',

    // Orders
    myOrdersTitle: 'Mano užsakymai',
    noOrders: 'Jūs dar neturite užsakymų.',
    orderHistory: 'Jūsų užsakymų istorija',
    orderLabel: 'Užsakymas',
    time: 'Laikas',
    noOrdersFiltered: 'Nėra užsakymų su pasirinktu filtru',
    all: 'Visi',
    orderStatusProcessing: 'Apdorojama',
    orderStatusShipped: 'Išsiųsta',
    orderStatusDelivered: 'Pristatyta',
    orderStatusCancelled: 'Atšaukta',
    firstOrderHere: 'Kai atliksite pirmąjį užsakymą, jis bus rodomas čia.',
    viewProducts: 'Peržiūrėti produktus',
    orderCount: 'Jūs turite {n} užsakymų',
    orderDetails: 'Užsakymo detalės',
    items: 'Prekės',
    shipping: 'Pristatymas',
    billing: 'Atsiskaitymas',
    paymentStatus: 'Mokėjimo būsena',
    pending: 'Laukiama',
    paid: 'Apmokėta',
    refunded: 'Grąžinta',

    // My account
    myAccountTitle: 'Mano paskyra',
    profile: 'Profilis',
    security: 'Saugumas',
    addresses: 'Adresai',
    twoFactorAuth: 'Dviejų lygių autentifikacija',

    // Favorites
    favoritesTitle: 'Mėgstamos prekės',
    noFavorites: 'Jūs dar neturite mėgstamų prekių.',

    // Contact
    contactTitle: 'Kontaktai',
    contactSubtitle: 'Susisiekite su mumis',
    subject: 'Tema',
    message: 'Žinutė',
    send: 'Siųsti',
    contactIntro: 'Turite klausimų? Užpildykite formą žemiau – atsakysime kuo greičiau.',
    contactNameLabel: 'Vardas ir pavardė arba įmonės pavadinimas *',
    contactNamePlaceholder: 'pvz. Jonas Jonaitis arba UAB Įmonė',
    contactMessagePlaceholder: 'Parašykite savo žinutę...',
    contactSuccess: 'Pranešimas sėkmingai išsiųstas. Susisieksime su jumis netrukus.',
    contactError: 'Nepavyko išsiųsti. Bandykite vėliau.',
    selectSubject: 'Pasirinkite temą',
    contactService: 'Susisiekti su aptarnavimu',
    contactQuality: 'Susisiekti dėl kokybės',
    contactWarranty: 'Susisiekti dėl garantijos',
    followUs: 'Sekite mus',
    shop: 'Parduotuvė',
    recommendedLink: 'Rekomenduojami',
    categories: 'Kategorijos',
    information: 'Informacija',
    aboutUs: 'Apie mus',
    returns: 'Grąžinimas',
    account: 'Paskyra',
    faq: 'DUK',
    allRightsReserved: 'Visos teisės saugomos',
    privacyPolicy: 'Privatumo politika',
    termsOfUse: 'Naudojimo sąlygos',
    cookieSettings: 'Slapukų nustatymai',
    registerError: 'Registracijos klaida',
    contactPrefix: 'Susisiekti su',
    contactPrefixAbout: 'Susisiekti dėl',
    salesShort: 'pardavimais',
    serviceShort: 'aptarnavimu',
    qualityShort: 'kokybės',
    warrantyShort: 'garantijos',

    // Cookie policy
    cookiePolicyTitle: 'Slapukų politika',

    // Checkout extra
    addressLine2: 'Papildoma informacija',
    selectShippingAddress: 'Pasirinkite pristatymo adresą',
    saveThisAddress: 'Išsaugoti šį adresą adresų knygoje',
    noShippingMethods: 'Pristatymo būdų nėra. Susisiekite su administratoriumi.',
    noPaymentMethods: 'Mokėjimo būdų nėra. Susisiekite su administratoriumi.',
    freeShipping: 'Nemokamai',
    storeCredits: 'Parduotuvės kreditai',
    storeCreditsAvailable: 'Turite galimybę naudoti',
    useStoreCredits: 'Naudoti parduotuvės kreditus',
    howMuchCredits: 'Kiek kreditų naudoti (maks. {amount} €)',
    orderSummary: 'Užsakymo santrauka',
    subtotal: 'Prekių suma',
    shippingCost: 'Pristatymo mokestis',
    taxAmount: 'PVM suma',
    creatingOrder: 'Kuriama...',

    // Papildomi Stripe būdai (kortelė, Apple Pay, Google Pay)
    paymentOptionCard: 'Kortelė',
    paymentOptionApplePay: 'Apple Pay',
    paymentOptionGooglePay: 'Google Pay',

    // Stripe mokėjimo parinktys (atsiskaitymo puslapyje)
    stripeOptionCard: 'Kortelė (Visa, Mastercard, Apple Pay, Google Pay)',
    stripeOptionPayPal: 'PayPal',
    stripeOptionLink: 'Stripe Link',
    stripeOptionIdeal: 'iDEAL',
    stripeOptionGiropay: 'Giropay',
    stripeOptionBancontact: 'Bancontact',

    // Mokėjimo patvirtinimas (Stripe return)
    paymentVerifying: 'Patvirtinamas mokėjimas...',
    paymentVerifyingHint: 'Prašome palaukti, tikriname mokėjimo statusą.',
    paymentSuccessTitle: 'Mokėjimas sėkmingas',
    paymentSuccessText: 'Jūsų užsakymas yra apdorojamas. Netrukus būsite nukreipti į užsakymo puslapį.',
    redirectingToOrder: 'Peradresuojame į užsakymą...',
    paymentConfirmFailed: 'Mokėjimo patvirtinimas nepavyko',
    paymentConfirmErrorText: 'Įvyko klaida patvirtinant mokėjimą. Susisiekite su palaikymu.',
    checkConsoleHint: 'Patikrinkite naršyklės konsolę (F12) dėl daugiau informacijos.',

    orderNotFound: 'Užsakymas nerastas',
    orderNotFoundText: 'Užsakymas, kurį ieškote, neegzistuoja arba buvo pašalintas.',
    backToOrders: 'Grįžti į užsakymus',
    orderStatusLabel: 'Užsakymo būsena',
    paymentStatusLabel: 'Apmokėjimo būsena',
    orderInfo: 'Užsakymo informacija',
    orderItems: 'Užsakymo prekės',
    notSpecified: 'Nenurodytas',
    returnSuccess: 'Grąžinimo prašymas sukurtas sėkmingai',
    returnError: 'Klaida kuriant grąžinimo prašymą',
    failed: 'Nepavyko',
    returnRequested: 'Prašoma',
    returnApproved: 'Patvirtinta',
    returnRejected: 'Atmesta',
    returnReceived: 'Gauta',
    accountSubtitle: 'Valdykite savo paskyros nustatymus ir informaciją',
    passwordTab: 'Slaptažodis',
    profileInfo: 'Profilio informacija',
    emailCannotChange: 'El. paštas negali būti keičiamas',
    profileUpdated: 'Profilis atnaujintas sėkmingai',
    profileUpdateError: 'Klaida atnaujinant profilį',
    passwordChanged: 'Slaptažodis pakeistas sėkmingai',
    passwordChangeError: 'Klaida keičiant slaptažodį',
    creditsTab: 'Kreditai',
    favoritesTabShort: 'Mėgstamos',
    favoritesSubtitle: 'Jūsų išsaugotų prekių sąrašas',
    emptyFavoritesText: 'Jūsų mėgstamų prekių sąrašas tuščias',
    emptyFavoritesHint: 'Pridėkite prekių į mėgstamus, kad jas būtų lengviau rasti vėliau.',
    errorRemovingFavorite: 'Klaida šalinant prekę',
    favoritesCount: '{n} prekė(-ės) jūsų sąraše',
    cookiePolicyLastUpdated: 'Paskutinį kartą atnaujinta',
    saveChanges: 'Išsaugoti pakeitimus',
    saving: 'Išsaugoma...',
    currentPassword: 'Dabartinis slaptažodis',
    changePassword: 'Keisti slaptažodį',
    changingPassword: 'Keičiama...',
    accountInfo: 'Paskyros informacija',
    accountCreated: 'Paskyra sukurta',
    lastLogin: 'Paskutinis prisijungimas',
    never: 'Niekada',
    emailVerification: 'El. pašto patvirtinimas',
    verified: 'Patvirtintas',
    notVerified: 'Nepatvirtintas',
    sendVerificationEmail: 'Siųsti patvirtinimo laišką',
    verificationEmailSent: 'Patvirtinimo laiškas išsiųstas. Patikrinkite el. paštą (ir šlamšto aplanką).',
    verifyEmailHint: 'Jei el. paštas nepatvirtintas, spustelėkite mygtuką – gausite nuorodą patvirtinimui.',
    verifyEmailTitle: 'El. pašto patvirtinimas',
    emailVerifiedSuccess: 'El. paštas sėkmingai patvirtintas. Galite grįžti į paskyrą.',
    verificationLinkExpired: 'Nuoroda nebegalioja arba jau panaudota. Paprašykite naujo patvirtinimo laiško iš Mano paskyros.',
    backToAccount: 'Grįžti į paskyrą',

    twoFactorTitle: 'Dviejų faktorių patvirtinimas',
    twoFactorEnabled: '2FA įjungta',
    twoFactorProtected: 'Jūsų paskyrą apsaugo dviejų faktorių patvirtinimas.',
    disable2FA: 'Išjungti 2FA',
    regenerateBackupCodes: 'Generuoti naujus atsarginius kodus',
    setup2FA: 'Nustatyti 2FA',
    twoFactorStep1: '1. Nuskaitykite QR kodą autentifikatoriaus programa (pvz. Google Authenticator, Authy):',
    orEnterManually: 'Arba įveskite rankiniu būdu:',
    twoFactorStep2: '2. Įveskite 6 skaitmenų kodą iš autentifikatoriaus programos:',
    verifying: 'Tikrinama...',
    backupCodesTitle: 'Atsarginiai kodai',
    backupCodesWarning: 'SVARBU: Išsaugokite šiuos atsarginius kodus saugioje vietoje. Jie bus rodomi tik vieną kartą!',
    done: 'Atlikta',
    twoFactorDisabled: '2FA išjungta',
    twoFactorDisabledDesc: 'Įjunkite dviejų faktorių patvirtinimą, kad padidintumėte paskyros saugumą.',
    how2FAWorks: 'Kaip veikia 2FA?',
    twoFAList1: 'Prisijungimo metu, be slaptažodžio, reikės įvesti kodą iš autentifikatoriaus programos',
    twoFAList2: 'Galite naudoti Google Authenticator, Authy ar kitą TOTP programą',
    twoFAList3: 'Gausite 10 atsarginių kodų, jei neturėtumėte prieigos prie autentifikatoriaus programos',
    enable2FA: 'Įjungti 2FA',
    settingUp: 'Nustatoma...',
    twoFADisabledSuccess: '2FA išjungta',
    errorDisabling2FA: 'Klaida išjungiant 2FA',
    backupCodesUpdated: 'Atsarginiai kodai atnaujinti',
    errorRegeneratingBackup: 'Klaida generuojant atsarginius kodus',
    enterPasswordToDisable2FA: 'Įveskite slaptažodį, kad išjungtumėte 2FA:',
    enterPasswordForBackupCodes: 'Įveskite slaptažodį, kad sugeneruotumėte naujus atsarginius kodus:',
    invalidCode: 'Neteisingas kodas',

    // Admin – meniu ir funkcijos
    admin_dashboard: 'Pagrindinis',
    admin_orders: 'Užsakymai',
    admin_assortment: 'Asortimentas',
    admin_products: 'Produktai',
    admin_categories: 'Kategorijos',
    admin_users: 'Vartotojai',
    admin_finance: 'Finansai',
    admin_invoices: 'Sąskaitos',
    admin_credit_invoices: 'Kreditinės sąskaitos',
    admin_store_credits: 'Store Credits',
    admin_promotions_nav: 'Naudos',
    admin_promotions: 'Akcijos',
    admin_coupons: 'Kuponai',
    admin_gift_cards: 'Dovanų kortelės',
    admin_loyalty: 'Lojalumas',
    admin_content: 'Turinys',
    admin_header_menu: 'Viršutinio meniu nuorodos',
    admin_home_page: 'Pirmasis puslapis',
    admin_pages: 'Puslapiai',
    admin_footer_links: 'Footerio nuorodos',
    admin_settings: 'Nustatymai',
    admin_store: 'Parduotuvė',
    admin_shipping: 'Pristatymas',
    admin_shipping_methods: 'Pristatymo metodai',
    admin_courier_integrations: 'Kurjerių integracijos (Unisend)',
    admin_finance_reports: 'Finansai',
    admin_payment_methods: 'Mokėjimai',
    admin_invoice_settings: 'Sąskaitų nustatymai',
    admin_email_automation: 'El. paštas',
    admin_smtp: 'SMTP nustatymai',
    admin_marketplace: 'Marketplace',
    admin_backups: 'Backup',
    admin_errors: 'Klaidos',
    admin_quick_actions: 'Greitieji veiksmai',
    admin_new_product: 'Naujas produktas',
    admin_search_placeholder: 'Ieškoti... (⌘K)',
    admin_search_placeholder_short: '⌘K',
    admin_back_to_store: 'Grįžti į parduotuvę',
    admin_collapse_sidebar: 'Suskleisti',
    admin_expand_sidebar: 'Išskleisti',
    admin_search_functions: 'Ieškoti funkcijų... (Esc - uždaryti)',
    admin_search_no_results: 'Nieko nerasta',

    // Admin – Mokėjimai (Nustatymai → Mokėjimai)
    paymentMethodsTitle: 'Mokėjimo priemonės',
    paymentMethodsSubtitle: 'Konfigūruokite mokėjimo priemones ir jų nustatymus',
    paymentMethodActive: 'Aktyvi',
    paymentMethodInactive: 'Neaktyvi',
    paymentMethodTestMode: 'Test režimas',
    paymentMethodEdit: 'Redaguoti',
    paymentMethodEditTitle: 'Redaguoti: {name}',
    paymentMethodEnable: 'Aktyvuoti mokėjimo priemonę',
    paymentMethodTestModeLabel: 'Test režimas',
    paymentMethodSortOrder: 'Rikiavimo eilės numeris',
    paymentMethodConfiguration: 'Konfigūracija',
    paymentMethodEnterPlaceholder: 'Įveskite {label}...',
    paymentMethodSuccessUpdate: 'Mokėjimo priemonė sėkmingai atnaujinta',
    paymentMethodErrorUpdate: 'Klaida atnaujinant mokėjimo priemonę',
    paymentMethodNameLt: 'Pavadinimas (lietuvių)',
    paymentMethodNameEn: 'Pavadinimas (anglų)',
    paymentMethodNameDe: 'Pavadinimas (vokiečių)',
    paymentMethodNameHint: 'Nustatykite norimą pavadinimą kiekvienai kalbai. Jei paliksite tuščią, naudojamas numatytasis.',
    paymentMethodDisplayMode: 'Rodymas parduotuvėje',
    paymentMethodDisplayName: 'Tik pavadinimas',
    paymentMethodDisplayImage: 'Tik paveikslėlis',
    paymentMethodDisplayNameAndImage: 'Pavadinimas ir paveikslėlis',
    paymentMethodImageUpload: 'Paveikslėlis',
    paymentMethodImageSelect: 'Įkelti iš kompiuterio',
    paymentMethodImageRemove: 'Pašalinti paveikslėlį',
    paymentMethodImageInvalid: 'Pasirinkite nuotraukos failą (JPG, PNG, GIF, WebP)',
    paymentMethodImageUploaded: 'Paveikslėlis įkeltas',
    paymentMethodImageUploadError: 'Nepavyko įkelti paveikslėlio',
    uploading: 'Kraunama...',
    paymentConfigTestSecretKey: 'Test slaptas raktas',
    paymentConfigTestPublishableKey: 'Test viešas raktas',
    paymentConfigLiveSecretKey: 'Tiesioginio mokėjimo slaptas raktas',
    paymentConfigLivePublishableKey: 'Tiesioginio mokėjimo viešas raktas',
    paymentConfigClientId: 'Client ID',
    paymentConfigClientSecret: 'Slaptas raktas',
    paymentConfigSandboxMode: 'Sandbox režimas',
    paymentConfigMerchantId: 'Pardavėjo ID',
    paymentConfigPrivateKey: 'Privatus raktas',
    paymentConfigBankUrl: 'Banko URL',
    stripeQuickMethodsTitle: 'Papildomi būdai (kortelė, Apple Pay, Google Pay)',
    stripeQuickMethodsHint: 'Pavadinimai ir paveikslėliai atsiskaitymo puslapyje. Jei tuščia – naudojami numatytieji.',
    stripeQuickCardTitle: 'Kortelė',
    stripeQuickApplePayTitle: 'Apple Pay',
    stripeQuickGooglePayTitle: 'Google Pay',

    paymentConfigBankAccountsHint: 'Nurodykite vieną ar kelias banko sąskaitas. Klientas matys visas – gali mokėti į bet kurią.',
    paymentConfigAddBankAccount: 'Pridėti banko sąskaitą',
    paymentConfigIban: 'IBAN',
    paymentConfigBankName: 'Bankas',
    paymentConfigBankNamePlaceholder: 'pvz. Swedbank',
    paymentConfigCompanyName: 'Gavėjas (įmonė / vardas)',
    paymentConfigCompanyNamePlaceholder: 'pvz. UAB Parduotuvė',
    paymentConfigRemoveAccount: 'Pašalinti sąskaitą',
    paymentConfigReferencePrefix: 'Paskirties prefiksas (nebūtina)',
    paymentConfigReferencePrefixPlaceholder: 'pvz. ORD arba palikite tuščią',
    paymentConfigInstructionsLt: 'Papildomos instrukcijos (lietuvių)',
    paymentConfigInstructionsEn: 'Papildomos instrukcijos (anglų)',
    paymentConfigInstructionsDe: 'Papildomos instrukcijos (vokiečių)',
    paymentConfigInstructionsPlaceholder: 'Tekstas, kuris bus rodomas po banko duomenų',
    bankTransferDefaultInstructionsLt: 'Sumą perveskite į nurodytą sąskaitą. Paskirtyje nurodykite užsakymo numerį.',
    bankTransferDefaultInstructionsEn: 'Transfer the amount to the account below. In the reference, indicate the order number.',
    bankTransferDefaultInstructionsDe: 'Überweisen Sie den Betrag auf das angegebene Konto. Geben Sie im Verwendungszweck die Bestellnummer an.',
    bankAccountLabel: 'Sąskaita',

    // Slapukai (Cookie consent)
    cookieBannerText: 'Naudojame slapukus, kad svetainė veiktų teisingai, būtų patogesnė naudoti ir analizuotume srautus. Detaliau –',
    cookiePolicyInLink: 'Slapukų politikoje',
    acceptAll: 'Priimti viską',
    cookieSettingsBtn: 'Nustatymai',
    rejectOptional: 'Atmesti neprivalomus',
    cookieSettingsIntro: 'Pasirinkite, kuriuos slapukus leidžiame naudoti:',
    necessaryCookies: 'Būtini – būtini svetainės veikimui (pvz. sesija, krepšelis). Juos išjungti negalima.',
    analyticsCookies: 'Analitika – padeda suprasti, kaip lankytojai naudoja svetainę.',
    marketingCookies: 'Rinkodara – naudojami asmeniniam turiniui ir reklamai.',
    saveChoice: 'Išsaugoti pasirinkimą',

    // Prieinamumas
    accessibilitySettingsTitle: 'Prieinamumo nustatymai',
    accessibilitySettingsDesc: 'Pritaikykite svetainę savo poreikiams. Nustatymai išsaugomi naršyklėje.',
    closeAccessibility: 'Uždaryti prieinamumo nustatymus',
    textSize: 'Teksto dydis',
    normalSize: 'Normalus',
    largerSize: 'Didesnis',
    evenLargerSize: 'Dar didesnis',
    contrast: 'Kontrastas',
    highContrast: 'Didelis kontrastas',
    reduceMotion: 'Sumažinti judesius',
    showFocusOutline: 'Visada rodyti fokusą (kontūrą)',
    underlineLinks: 'Pabraukti nuorodas',
    resetSettings: 'Atstatyti nustatymus',

    // Krepšelio puslapis
    cartSummary: 'Krepšelio santrauka',
    withoutVAT: 'be PVM',

    // Užsakymo peržiūra / PDF / Grąžinimas
    orderNotesLabel: 'Pastabos',
    invoiceTitle: 'Sąskaita faktūra',
    invoiceNumber: 'Sąskaitos numeris',
    issueDate: 'Išrašymo data',
    dueDate: 'Mokėjimo terminas',
    draft: 'Juodraštis',
    downloadPdfInvoice: 'Parsisiųsti PDF sąskaitą faktūrą',
    loginRequiredInvoice: 'Reikia prisijungti, kad parsisiųstumėte sąskaitą faktūrą',
    errorDownloadingPdf: 'Nepavyko parsisiųsti PDF',
    productReturns: 'Prekių grąžinimas',
    yourReturnRequests: 'Jūsų grąžinimo prašymai',
    returnNumberLabel: 'Grąžinimo numeris',
    reasonLabel: 'Priežastis',
    refundAmount: 'Grąžinimo suma',
    trackingNumber: 'Siuntos numeris',
    cancelReturnConfirm: 'Ar tikrai norite atšaukti šį grąžinimo prašymą?',
    confirmCancelReturn: 'Patvirtinti grąžinimo atšaukimą',
    returnCancelled: 'Grąžinimo prašymas atšauktas',
    errorCancellingReturn: 'Klaida atšaukiant grąžinimą',
    cancelReturn: 'Atšaukti grąžinimą',
    initiateReturn: 'Inicijuoti prekių grąžinimą',
    newReturnRequest: 'Naujas grąžinimo prašymas',
    selectItemsForReturn: 'Pasirinkite prekes grąžinimui',
    selectAtLeastOneItem: 'Pasirinkite bent vieną prekę grąžinimui',
    returnReasonRequired: 'Nurodykite grąžinimo priežastį',
    selectReasonPlaceholder: 'Pasirinkite priežastį...',
    returnReasonLabel: 'Grąžinimo priežastis *',
    additionalNotes: 'Papildomos pastabos',
    returnNotesPlaceholder: 'Papildoma informacija apie grąžinimą...',
    submitReturnRequest: 'Pateikti grąžinimo prašymą',
    reasonDefective: 'Prekė su defektais',
    reasonWrongItem: 'Netinkama prekė',
    reasonNotAsDescribed: 'Nesutampa su aprašymu',
    reasonDamaged: 'Prekė pažeista pristatymo metu',
    reasonChangedMind: 'Pakeitė nuomonę',
    reasonOther: 'Kita priežastis',
    taxLabel21: 'PVM (21%)',

    // Parduotuvės kreditai
    storeCreditsTitle: 'Parduotuvės kreditai',
    totalBalance: 'Bendras balansas',
    noStoreCredits: 'Jūs neturite parduotuvės kreditų.',
    creditsInfo: 'Kreditai gali būti suteikti grąžinant prekes arba kaip kompensacija už problemą.',
    creditsHistory: 'Kreditų istorija',
    balance: 'Balansas',
    validUntil: 'Galioja iki',
    creditSourceRefund: 'Grąžinimas',
    creditSourceManual: 'Rankinis',
    creditSourcePromotion: 'Akcija',

    myAddresses: 'Mano adresai',
    addNewAddress: 'Pridėti naują adresą',
    editAddress: 'Redaguoti adresą',
    addressType: 'Adreso tipas',
    bothAddressTypes: 'Abu',
    confirmDeleteAddress: 'Ar tikrai norite pašalinti šį adresą?',
    addressAdded: 'Adresas sėkmingai pridėtas',
    addressUpdated: 'Adresas sėkmingai atnaujintas',
    addressRemoved: 'Adresas sėkmingai pašalintas',
    defaultAddressSet: 'Numatytasis adresas nustatytas',
    errorAddingAddress: 'Klaida pridedant adresą',
    errorUpdatingAddress: 'Klaida atnaujinant adresą',
    errorRemovingAddress: 'Klaida šalinant adresą',
    errorSettingDefault: 'Klaida nustatant numatytąjį adresą',
    setAsDefaultAddress: 'Nustatyti kaip numatytąjį adresą',
    addAddress: 'Pridėti adresą',
    setAsDefault: 'Nustatyti kaip numatytąjį',
    bothAddressesLabel: 'Pristatymo ir atsiskaitymo adresas',
    noAddressesMessage: 'Jūs neturite išsaugotų adresų. Pridėkite pirmąjį adresą',

    // Banko pavedimas
    bankTransfer: 'Banko pavedimas',
    bankTransferInstructions: 'Mokėjimo instrukcijos',
    paymentReference: 'Paskirtis',
    iban: 'IBAN',
    bankName: 'Bankas',
    companyName: 'Gavėjas',
    amountToPay: 'Suma apmokėti',
  },
  en: {
    loading: 'Loading...',
    submit: 'Submit',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    back: 'Back',
    next: 'Next',
    close: 'Close',
    search: 'Search',
    noResults: 'No results found',
    error: 'Error',
    success: 'Success',

    menu: 'Menu',
    home: 'Home',
    products: 'Products',
    cart: 'Cart',
    myAccount: 'My account',
    myOrders: 'My orders',
    myFavorites: 'Favorites',
    login: 'Log in',
    logout: 'Log out',
    admin: 'Admin',
    accessibility: 'Accessibility settings',
    openAccessibility: 'Open accessibility settings',

    pageNotFound: 'Page not found',
    checkUrl: 'Please check the URL.',
    pageContent: 'Page content',

    yourCart: 'Your shopping cart',
    emptyCart: 'Your cart is empty',
    emptyCartHint: 'Add items to your cart to get started.',
    continueShopping: 'Continue shopping',
    checkout: 'Checkout',
    quantity: 'Quantity',
    price: 'Price',
    total: 'Total',
    remove: 'Remove',

    product: 'Product',
    addToCart: 'Add to cart',
    outOfStock: 'Out of stock',
    sale: 'Sale',
    qualityGoods: 'Quality products',
    bestGoods: 'Best products at a fair price',
    viewAll: 'View all',

    orders: 'Orders',
    orderNumber: 'Order no.',
    orderDate: 'Date',
    orderStatus: 'Status',
    viewOrder: 'View order',
    payNow: 'Pay',
    redirectingToPayment: 'Redirecting to payment...',
    paymentSessionError: 'Failed to start payment. Please try again.',

    register: 'Register',
    forgotPassword: 'Forgot password?',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    firstName: 'First name',
    lastName: 'Last name',
    phone: 'Phone',

    contact: 'Contact',
    contactSales: 'Contact sales',
    cookies: 'Cookies',

    language: 'Language',
    lang_lt: 'LT',
    lang_en: 'EN',
    lang_de: 'DE',

    shopNow: 'Shop now',
    quality: 'Quality',
    qualityText: 'Choose quality products that last. Every item is selected to the highest standards.',
    fastDelivery: 'Fast delivery',
    fastDeliveryText: 'We deliver your orders quickly and safely across the country. Reliable delivery to your door.',
    greatService: 'Great service',
    greatServiceText: 'Our team is always ready to help and answer your questions. Professional service for every customer.',
    discoverMore: 'Discover more',
    discoverMoreText: 'Magtic is a store offering quality products at fair prices. Our mission is to give you the best choice and experience.',
    viewFullRange: 'View full range',
    testimonialQuote: 'Great product choice and fast delivery. Very happy with my purchase!',
    regularCustomer: 'Regular customer',
    newLevel: 'New level',
    newLevelText: 'Discover quality products that improve your everyday life. Choose from a wide range and enjoy great service.',
    viewMore: 'View more',
    allProducts: 'All products',

    category: 'Category',
    allCategories: 'All categories',
    sortBy: 'Sort by',
    sortProducts: 'Sort products',
    filterByCategory: 'Filter by category',
    newest: 'Newest',
    nameAz: 'Name A–Z',
    nameZa: 'Name Z–A',
    priceAsc: 'Price: low to high',
    priceDesc: 'Price: high to low',
    searchProducts: 'Search products',
    addedToCart: 'Item added to cart',
    errorAddingToCart: 'Error adding item',
    loadMore: 'Loading more...',

    variant: 'Variant',
    addToFavorites: 'Add to favorites',
    removeFromFavorites: 'Remove from favorites',
    description: 'Description',
    specifications: 'Specifications',
    sku: 'SKU',
    barcode: 'Barcode',
    packageDimensions: 'Package dimensions',
    packageSize: 'Package size',
    youMayAlsoLike: 'You may also like',
    productNotFound: 'Product not found',
    noImage: 'No image',
    addedToFavorites: 'Added to favorites',
    removedFromFavorites: 'Removed from favorites',
    loginRequiredFavorites: 'Please log in to use favorites',
    sending: 'Sending...',
    forgotPasswordSuccess: 'If that email exists, we sent a reset link. Check your inbox.',
    tryAgainLater: 'Error. Please try again later.',
    backToLogin: 'Back to login',
    selectedVariant: 'Selected variant',
    selected: 'Selected',
    inStock: 'In stock',
    outOfStockLabel: 'Out of stock',
    adding: 'Adding...',
    saleEnds: 'Sale ends',
    recommended: 'Recommended',
    reviews: 'Reviews',
    collections: 'Collections',
    video: 'Video',
    stockQuantity: 'Stock',
    productIncludes: 'This product includes',
    bundleQuantity: 'Quantity',
    bundleDiscount: 'Discount',
    reviewsCount: '{n} reviews',
    backToProducts: '← All products',
    selectSize: 'Select size',
    sizeGuide: 'Size guide',
    averageRating: 'Average rating',
    outOfFive: 'out of 5',

    checkoutTitle: 'Checkout',
    checkoutSubtitle: 'Fill in your details and place your order',
    billingAddress: 'Billing address',
    selectSavedAddresses: 'Choose from saved addresses',
    enterNewAddress: 'Enter new address',
    selectBillingAddress: 'Select billing address',
    selectAddress: 'Select address...',
    defaultAddress: 'Default',
    company: 'Company',
    address: 'Address',
    addressExtra: 'Address line 2',
    city: 'City',
    postalCode: 'Postal code',
    country: 'Country',
    shippingAddress: 'Shipping address',
    sameAsBilling: 'Same as billing',
    shippingSameAsBilling: 'Shipping address same as billing',
    deliveryMethod: 'Delivery method',
    selectDelivery: 'Select delivery method',
    paymentMethod: 'Payment method',
    selectPayment: 'Select payment method',
    orderNotes: 'Order notes',
    placeOrder: 'Place order',
    cartEmpty: 'Your cart is empty',
    chooseShipping: 'Choose delivery method',
    choosePayment: 'Choose payment method',
    paymentOptionCard: 'Card',
    paymentOptionApplePay: 'Apple Pay',
    paymentOptionGooglePay: 'Google Pay',

    loginTitle: 'Log in',
    loginSubtitle: 'Enter your email and password',
    registerSubtitle: 'Create an account',
    toHome: 'Back to home',
    loginError: 'Login error',
    loggedOutDueToInactivity: 'You were logged out due to inactivity (more than 2 hours). Please log in again.',
    or: 'or',
    noAccount: "Don't have an account?",
    forgotPasswordLink: 'Forgot password',
    forgotPasswordTitle: 'Password recovery',
    forgotPasswordSubtitle: 'Enter your email and we will send you a reset link',
    sendResetLink: 'Send link',
    resetPasswordTitle: 'Set new password',
    newPassword: 'New password',
    resetPassword: 'Reset password',
    passwordRequirements: 'Password requirements',
    minChars: 'At least 8 characters',
    oneUpperCase: 'At least one uppercase letter',
    oneLowerCase: 'At least one lowercase letter',
    oneNumber: 'At least one number',
    oneSymbol: 'At least one special character',
    passwordMismatch: 'Passwords do not match',

    myOrdersTitle: 'My orders',
    noOrders: "You don't have any orders yet.",
    orderHistory: 'Your order history',
    orderLabel: 'Order',
    time: 'Time',
    noOrdersFiltered: 'No orders match this filter',
    all: 'All',
    orderStatusProcessing: 'Processing',
    orderStatusShipped: 'Shipped',
    orderStatusDelivered: 'Delivered',
    orderStatusCancelled: 'Cancelled',
    firstOrderHere: 'When you place your first order, it will appear here.',
    viewProducts: 'View products',
    orderCount: 'You have {n} order(s)',
    orderDetails: 'Order details',
    items: 'Items',
    shipping: 'Shipping',
    billing: 'Billing',
    pending: 'Pending',
    paid: 'Paid',
    refunded: 'Refunded',

    myAccountTitle: 'My account',
    profile: 'Profile',
    security: 'Security',
    addresses: 'Addresses',
    twoFactorAuth: 'Two-factor authentication',

    favoritesTitle: 'Favorites',
    noFavorites: "You don't have any favorites yet.",

    contactTitle: 'Contact',
    contactSubtitle: 'Get in touch with us',
    subject: 'Subject',
    message: 'Message',
    send: 'Send',
    contactIntro: 'Have questions? Fill in the form below and we will get back to you as soon as possible.',
    contactNameLabel: 'Full name or company name *',
    contactNamePlaceholder: 'e.g. John Smith or Acme Inc.',
    contactMessagePlaceholder: 'Write your message...',
    contactSuccess: 'Message sent successfully. We will contact you soon.',
    contactError: 'Failed to send. Please try again later.',
    selectSubject: 'Select subject',
    contactService: 'Customer service',
    contactQuality: 'Quality enquiry',
    contactWarranty: 'Warranty',
    followUs: 'Follow us',
    shop: 'Shop',
    recommendedLink: 'Recommended',
    categories: 'Categories',
    information: 'Information',
    aboutUs: 'About us',
    returns: 'Returns',
    account: 'Account',
    faq: 'FAQ',
    allRightsReserved: 'All rights reserved.',
    privacyPolicy: 'Privacy policy',
    termsOfUse: 'Terms of use',
    cookieSettings: 'Cookie settings',
    registerError: 'Registration error',
    contactPrefix: 'Contact',
    contactPrefixAbout: 'About',
    salesShort: 'sales',
    serviceShort: 'service',
    qualityShort: 'quality',
    warrantyShort: 'warranty',

    cookiePolicyTitle: 'Cookie policy',

    addressLine2: 'Address line 2',
    selectShippingAddress: 'Select shipping address',
    saveThisAddress: 'Save this address to address book',
    noShippingMethods: 'No delivery methods. Please contact the administrator.',
    noPaymentMethods: 'No payment methods. Please contact the administrator.',
    freeShipping: 'Free',
    storeCredits: 'Store credits',
    storeCreditsAvailable: 'You can use',
    useStoreCredits: 'Use store credits',
    howMuchCredits: 'Amount to use (max. {amount} €)',
    orderSummary: 'Order summary',
    subtotal: 'Subtotal',
    shippingCost: 'Shipping',
    taxAmount: 'VAT',
    creatingOrder: 'Creating order...',

    stripeOptionCard: 'Card (Visa, Mastercard, Apple Pay, Google Pay)',
    stripeOptionPayPal: 'PayPal',
    stripeOptionLink: 'Stripe Link',
    stripeOptionIdeal: 'iDEAL',
    stripeOptionGiropay: 'Giropay',
    stripeOptionBancontact: 'Bancontact',

    paymentVerifying: 'Verifying payment...',
    paymentVerifyingHint: 'Please wait while we check your payment status.',
    paymentSuccessTitle: 'Payment successful',
    paymentSuccessText: 'Your order is being processed. You will be redirected to the order page shortly.',
    redirectingToOrder: 'Redirecting to order...',
    paymentConfirmFailed: 'Payment confirmation failed',
    paymentConfirmErrorText: 'An error occurred while confirming the payment. Please contact support.',
    checkConsoleHint: 'Check the browser console (F12) for more information.',

    orderNotFound: 'Order not found',
    orderNotFoundText: 'The order you are looking for does not exist or has been removed.',
    backToOrders: 'Back to orders',
    orderStatusLabel: 'Order status',
    paymentStatusLabel: 'Payment status',
    orderInfo: 'Order information',
    orderItems: 'Order items',
    notSpecified: 'Not specified',
    returnSuccess: 'Return request created successfully',
    returnError: 'Error creating return request',
    failed: 'Failed',
    returnRequested: 'Requested',
    returnApproved: 'Approved',
    returnRejected: 'Rejected',
    returnReceived: 'Received',
    accountSubtitle: 'Manage your account settings and information',
    passwordTab: 'Password',
    profileInfo: 'Profile information',
    emailCannotChange: 'Email cannot be changed',
    profileUpdated: 'Profile updated successfully',
    profileUpdateError: 'Error updating profile',
    passwordChanged: 'Password changed successfully',
    passwordChangeError: 'Error changing password',
    creditsTab: 'Credits',
    favoritesTabShort: 'Favorites',
    favoritesSubtitle: 'Your saved items list',
    emptyFavoritesText: 'Your favorites list is empty',
    emptyFavoritesHint: 'Add items to favorites to find them easily later.',
    errorRemovingFavorite: 'Error removing item',
    favoritesCount: '{n} item(s) in your list',
    cookiePolicyLastUpdated: 'Last updated',
    saveChanges: 'Save changes',
    saving: 'Saving...',
    currentPassword: 'Current password',
    changePassword: 'Change password',
    changingPassword: 'Changing...',
    accountInfo: 'Account information',
    accountCreated: 'Account created',
    lastLogin: 'Last login',
    never: 'Never',
    emailVerification: 'Email verification',
    verified: 'Verified',
    notVerified: 'Not verified',
    sendVerificationEmail: 'Send verification email',
    verificationEmailSent: 'Verification email sent. Please check your inbox (and spam folder).',
    verifyEmailHint: 'If your email is not verified, click the button to receive a verification link.',
    verifyEmailTitle: 'Email verification',
    emailVerifiedSuccess: 'Email verified successfully. You can return to your account.',
    verificationLinkExpired: 'Link has expired or was already used. Request a new verification email from My account.',
    backToAccount: 'Back to account',

    admin_dashboard: 'Dashboard',
    admin_orders: 'Orders',
    admin_assortment: 'Assortment',
    admin_products: 'Products',
    admin_categories: 'Categories',
    admin_users: 'Users',
    admin_finance: 'Finance',
    admin_invoices: 'Invoices',
    admin_credit_invoices: 'Credit invoices',
    admin_store_credits: 'Store Credits',
    admin_promotions_nav: 'Promotions',
    admin_promotions: 'Promotions',
    admin_coupons: 'Coupons',
    admin_gift_cards: 'Gift cards',
    admin_loyalty: 'Loyalty',
    admin_content: 'Content',
    admin_header_menu: 'Header menu links',
    admin_home_page: 'Home page',
    admin_pages: 'Pages',
    admin_footer_links: 'Footer links',
    admin_settings: 'Settings',
    admin_store: 'Store',
    admin_shipping: 'Shipping',
    admin_shipping_methods: 'Shipping methods',
    admin_courier_integrations: 'Courier integrations (Unisend)',
    admin_finance_reports: 'Finance',
    admin_payment_methods: 'Payment methods',
    admin_invoice_settings: 'Invoice settings',
    admin_email_automation: 'Email',
    admin_smtp: 'SMTP settings',
    admin_marketplace: 'Marketplace',
    admin_backups: 'Backup',
    admin_errors: 'Errors',
    admin_quick_actions: 'Quick actions',
    admin_new_product: 'New product',
    admin_search_placeholder: 'Search... (⌘K)',
    admin_search_placeholder_short: '⌘K',
    admin_back_to_store: 'Back to store',
    admin_collapse_sidebar: 'Collapse',
    admin_expand_sidebar: 'Expand',
    admin_search_functions: 'Search functions... (Esc to close)',
    admin_search_no_results: 'No results for',

    // Admin – Payment methods (Settings → Payments)
    paymentMethodsTitle: 'Payment methods',
    paymentMethodsSubtitle: 'Configure payment methods and their settings',
    paymentMethodActive: 'Active',
    paymentMethodInactive: 'Inactive',
    paymentMethodTestMode: 'Test mode',
    paymentMethodEdit: 'Edit',
    paymentMethodEditTitle: 'Edit: {name}',
    paymentMethodEnable: 'Enable payment method',
    paymentMethodTestModeLabel: 'Test mode',
    paymentMethodSortOrder: 'Sort order',
    paymentMethodConfiguration: 'Configuration',
    paymentMethodEnterPlaceholder: 'Enter {label}...',
    paymentMethodSuccessUpdate: 'Payment method updated successfully',
    paymentMethodErrorUpdate: 'Error updating payment method',
    paymentMethodNameLt: 'Name (Lithuanian)',
    paymentMethodNameEn: 'Name (English)',
    paymentMethodNameDe: 'Name (German)',
    paymentMethodNameHint: 'Set the display name for each language. If left empty, the default is used.',
    paymentMethodDisplayMode: 'Display in store',
    paymentMethodDisplayName: 'Name only',
    paymentMethodDisplayImage: 'Image only',
    paymentMethodDisplayNameAndImage: 'Name and image',
    paymentMethodImageUpload: 'Image',
    paymentMethodImageSelect: 'Upload from computer',
    paymentMethodImageRemove: 'Remove image',
    paymentMethodImageInvalid: 'Please select an image file (JPG, PNG, GIF, WebP)',
    paymentMethodImageUploaded: 'Image uploaded',
    paymentMethodImageUploadError: 'Failed to upload image',
    uploading: 'Uploading...',
    paymentConfigTestSecretKey: 'Test secret key',
    paymentConfigTestPublishableKey: 'Test publishable key',
    paymentConfigLiveSecretKey: 'Live secret key',
    paymentConfigLivePublishableKey: 'Live publishable key',
    paymentConfigClientId: 'Client ID',
    paymentConfigClientSecret: 'Client secret',
    paymentConfigSandboxMode: 'Sandbox mode',
    paymentConfigMerchantId: 'Merchant ID',
    paymentConfigPrivateKey: 'Private key',
    paymentConfigBankUrl: 'Bank URL',
    stripeQuickMethodsTitle: 'Additional methods (Card, Apple Pay, Google Pay)',
    stripeQuickMethodsHint: 'Display name and image on checkout. If empty, defaults are used.',
    stripeQuickCardTitle: 'Card',
    stripeQuickApplePayTitle: 'Apple Pay',
    stripeQuickGooglePayTitle: 'Google Pay',

    paymentConfigBankAccountsHint: 'Add one or more bank accounts. Customers will see all and can pay to any.',
    paymentConfigAddBankAccount: 'Add bank account',
    paymentConfigIban: 'IBAN',
    paymentConfigBankName: 'Bank name',
    paymentConfigBankNamePlaceholder: 'e.g. Swedbank',
    paymentConfigCompanyName: 'Beneficiary (company / name)',
    paymentConfigCompanyNamePlaceholder: 'e.g. Company Ltd',
    paymentConfigRemoveAccount: 'Remove account',
    paymentConfigReferencePrefix: 'Reference prefix (optional)',
    paymentConfigReferencePrefixPlaceholder: 'e.g. ORD or leave empty',
    paymentConfigInstructionsLt: 'Additional instructions (Lithuanian)',
    paymentConfigInstructionsEn: 'Additional instructions (English)',
    paymentConfigInstructionsDe: 'Additional instructions (German)',
    paymentConfigInstructionsPlaceholder: 'Text shown below bank details',
    bankTransferDefaultInstructionsLt: 'Sumą perveskite į nurodytą sąskaitą. Paskirtyje nurodykite užsakymo numerį.',
    bankTransferDefaultInstructionsEn: 'Transfer the amount to the account below. In the reference, indicate the order number.',
    bankTransferDefaultInstructionsDe: 'Überweisen Sie den Betrag auf das angegebene Konto. Geben Sie im Verwendungszweck die Bestellnummer an.',
    bankAccountLabel: 'Account',

    cookieBannerText: 'We use cookies so the site works correctly, is easier to use and we can analyse traffic. For more –',
    cookiePolicyInLink: 'Cookie policy',
    acceptAll: 'Accept all',
    cookieSettingsBtn: 'Settings',
    rejectOptional: 'Reject optional',
    cookieSettingsIntro: 'Choose which cookies we may use:',
    necessaryCookies: 'Necessary – required for the site to work (e.g. session, cart). They cannot be disabled.',
    analyticsCookies: 'Analytics – helps us understand how visitors use the site.',
    marketingCookies: 'Marketing – used for personalised content and advertising.',
    saveChoice: 'Save choice',

    accessibilitySettingsTitle: 'Accessibility settings',
    accessibilitySettingsDesc: 'Adapt the site to your needs. Settings are saved in your browser.',
    closeAccessibility: 'Close accessibility settings',
    textSize: 'Text size',
    normalSize: 'Normal',
    largerSize: 'Larger',
    evenLargerSize: 'Even larger',
    contrast: 'Contrast',
    highContrast: 'High contrast',
    reduceMotion: 'Reduce motion',
    showFocusOutline: 'Always show focus outline',
    underlineLinks: 'Underline links',
    resetSettings: 'Reset settings',

    cartSummary: 'Cart summary',
    withoutVAT: 'excl. VAT',

    orderNotesLabel: 'Notes',
    invoiceTitle: 'Invoice',
    invoiceNumber: 'Invoice number',
    issueDate: 'Issue date',
    dueDate: 'Due date',
    draft: 'Draft',
    downloadPdfInvoice: 'Download PDF invoice',
    loginRequiredInvoice: 'Please log in to download the invoice',
    errorDownloadingPdf: 'Failed to download PDF',
    productReturns: 'Product returns',
    yourReturnRequests: 'Your return requests',
    returnNumberLabel: 'Return number',
    reasonLabel: 'Reason',
    refundAmount: 'Refund amount',
    trackingNumber: 'Tracking number',
    cancelReturnConfirm: 'Are you sure you want to cancel this return request?',
    confirmCancelReturn: 'Confirm return cancellation',
    returnCancelled: 'Return request cancelled',
    errorCancellingReturn: 'Error cancelling return',
    cancelReturn: 'Cancel return',
    initiateReturn: 'Initiate product return',
    newReturnRequest: 'New return request',
    selectItemsForReturn: 'Select items for return',
    selectAtLeastOneItem: 'Select at least one item for return',
    returnReasonRequired: 'Please specify the return reason',
    selectReasonPlaceholder: 'Select reason...',
    returnReasonLabel: 'Return reason *',
    additionalNotes: 'Additional notes',
    returnNotesPlaceholder: 'Additional information about the return...',
    submitReturnRequest: 'Submit return request',
    reasonDefective: 'Defective product',
    reasonWrongItem: 'Wrong item',
    reasonNotAsDescribed: 'Not as described',
    reasonDamaged: 'Damaged in delivery',
    reasonChangedMind: 'Changed mind',
    reasonOther: 'Other reason',
    taxLabel21: 'VAT (21%)',

    storeCreditsTitle: 'Store credits',
    totalBalance: 'Total balance',
    noStoreCredits: 'You have no store credits.',
    creditsInfo: 'Credits may be granted for returns or as compensation.',
    creditsHistory: 'Credit history',
    balance: 'Balance',
    validUntil: 'Valid until',
    creditSourceRefund: 'Refund',
    creditSourceManual: 'Manual',
    creditSourcePromotion: 'Promotion',

    twoFactorTitle: 'Two-factor authentication',
    twoFactorEnabled: '2FA enabled',
    twoFactorProtected: 'Your account is protected by two-factor authentication.',
    disable2FA: 'Disable 2FA',
    regenerateBackupCodes: 'Generate new backup codes',
    setup2FA: 'Set up 2FA',
    twoFactorStep1: '1. Scan the QR code with an authenticator app (e.g. Google Authenticator, Authy):',
    orEnterManually: 'Or enter manually:',
    twoFactorStep2: '2. Enter the 6-digit code from your authenticator app:',
    verifying: 'Verifying...',
    backupCodesTitle: 'Backup codes',
    backupCodesWarning: 'IMPORTANT: Save these backup codes in a secure place. They will only be shown once!',
    done: 'Done',
    twoFactorDisabled: '2FA disabled',
    twoFactorDisabledDesc: 'Enable two-factor authentication to increase account security.',
    how2FAWorks: 'How does 2FA work?',
    twoFAList1: 'When logging in you will need to enter a code from your authenticator app in addition to your password',
    twoFAList2: 'You can use Google Authenticator, Authy or another TOTP app',
    twoFAList3: 'You will receive 10 backup codes to use if you do not have access to your authenticator app',
    enable2FA: 'Enable 2FA',
    settingUp: 'Setting up...',
    twoFADisabledSuccess: '2FA disabled',
    errorDisabling2FA: 'Error disabling 2FA',
    backupCodesUpdated: 'Backup codes updated',
    errorRegeneratingBackup: 'Error generating backup codes',
    enterPasswordToDisable2FA: 'Enter your password to disable 2FA:',
    enterPasswordForBackupCodes: 'Enter your password to generate new backup codes:',
    invalidCode: 'Invalid code',

    myAddresses: 'My addresses',
    addNewAddress: 'Add new address',
    editAddress: 'Edit address',
    addressType: 'Address type',
    bothAddressTypes: 'Both',
    confirmDeleteAddress: 'Are you sure you want to remove this address?',
    addressAdded: 'Address added successfully',
    addressUpdated: 'Address updated successfully',
    addressRemoved: 'Address removed successfully',
    defaultAddressSet: 'Default address set',
    errorAddingAddress: 'Error adding address',
    errorUpdatingAddress: 'Error updating address',
    errorRemovingAddress: 'Error removing address',
    errorSettingDefault: 'Error setting default address',
    setAsDefaultAddress: 'Set as default address',
    addAddress: 'Add address',
    setAsDefault: 'Set as default',
    bothAddressesLabel: 'Shipping and billing address',
    noAddressesMessage: 'You have no saved addresses. Add your first address.',

    bankTransfer: 'Bank transfer',
    bankTransferInstructions: 'Payment instructions',
    paymentReference: 'Payment reference',
    iban: 'IBAN',
    bankName: 'Bank name',
    companyName: 'Beneficiary',
    amountToPay: 'Amount to pay',
  },
  de: {
    loading: 'Wird geladen...',
    submit: 'Absenden',
    cancel: 'Abbrechen',
    save: 'Speichern',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    back: 'Zurück',
    next: 'Weiter',
    close: 'Schließen',
    search: 'Suchen',
    noResults: 'Keine Ergebnisse',
    error: 'Fehler',
    success: 'Erfolgreich',

    menu: 'Menü',
    home: 'Startseite',
    products: 'Produkte',
    cart: 'Warenkorb',
    myAccount: 'Mein Konto',
    myOrders: 'Meine Bestellungen',
    myFavorites: 'Favoriten',
    login: 'Anmelden',
    logout: 'Abmelden',
    admin: 'Verwaltung',
    accessibility: 'Barrierefreiheit',
    openAccessibility: 'Barrierefreiheit öffnen',

    pageNotFound: 'Seite nicht gefunden',
    checkUrl: 'Bitte überprüfen Sie die URL.',
    pageContent: 'Seiteninhalt',

    yourCart: 'Ihr Warenkorb',
    emptyCart: 'Ihr Warenkorb ist leer',
    emptyCartHint: 'Fügen Sie Artikel zu Ihrem Warenkorb hinzu.',
    continueShopping: 'Weiter einkaufen',
    checkout: 'Zur Kasse',
    quantity: 'Menge',
    price: 'Preis',
    total: 'Summe',
    remove: 'Entfernen',

    product: 'Produkt',
    addToCart: 'In den Warenkorb',
    outOfStock: 'Ausverkauft',
    sale: 'Angebot',
    qualityGoods: 'Qualitätswaren',
    bestGoods: 'Beste Produkte zu fairen Preisen',
    viewAll: 'Alle anzeigen',

    orders: 'Bestellungen',
    orderNumber: 'Bestellnr.',
    orderDate: 'Datum',
    orderStatus: 'Status',
    viewOrder: 'Bestellung anzeigen',
    payNow: 'Bezahlen',
    redirectingToPayment: 'Weiterleitung zur Zahlung...',
    paymentSessionError: 'Zahlung konnte nicht gestartet werden. Bitte versuchen Sie es später erneut.',

    register: 'Registrieren',
    forgotPassword: 'Passwort vergessen?',
    email: 'E-Mail',
    password: 'Passwort',
    confirmPassword: 'Passwort bestätigen',
    firstName: 'Vorname',
    lastName: 'Nachname',
    phone: 'Telefon',

    contact: 'Kontakt',
    contactSales: 'Verkauf kontaktieren',
    cookies: 'Cookies',

    language: 'Sprache',
    lang_lt: 'LT',
    lang_en: 'EN',
    lang_de: 'DE',

    shopNow: 'Jetzt einkaufen',
    quality: 'Qualität',
    qualityText: 'Wählen Sie qualitativ hochwertige Produkte, die lange halten. Jedes Produkt erfüllt höchste Standards.',
    fastDelivery: 'Schnelle Lieferung',
    fastDeliveryText: 'Wir liefern Ihre Bestellungen schnell und sicher. Zuverlässige Lieferung bis zu Ihnen nach Hause.',
    greatService: 'Großartiger Service',
    greatServiceText: 'Unser Team hilft Ihnen gerne und beantwortet Ihre Fragen. Professioneller Service für jeden Kunden.',
    discoverMore: 'Mehr entdecken',
    discoverMoreText: 'Magtic ist ein Shop mit Qualitätsprodukten zu fairen Preisen. Unsere Mission: beste Auswahl und Erlebnis.',
    viewFullRange: 'Volles Sortiment anzeigen',
    testimonialQuote: 'Tolle Auswahl und schnelle Lieferung. Sehr zufrieden mit meinem Einkauf!',
    regularCustomer: 'Stammkunde',
    newLevel: 'Neues Level',
    newLevelText: 'Entdecken Sie Qualitätsprodukte für Ihren Alltag. Wählen Sie aus unserem Sortiment und genießen Sie unseren Service.',
    viewMore: 'Mehr anzeigen',
    allProducts: 'Alle Produkte',

    category: 'Kategorie',
    allCategories: 'Alle Kategorien',
    sortBy: 'Sortieren',
    sortProducts: 'Produkte sortieren',
    filterByCategory: 'Nach Kategorie filtern',
    newest: 'Neueste',
    nameAz: 'Name A–Z',
    nameZa: 'Name Z–A',
    priceAsc: 'Preis aufsteigend',
    priceDesc: 'Preis absteigend',
    searchProducts: 'Produkte suchen',
    addedToCart: 'Artikel in den Warenkorb gelegt',
    errorAddingToCart: 'Fehler beim Hinzufügen',
    loadMore: 'Weitere werden geladen...',

    variant: 'Variante',
    addToFavorites: 'Zu Favoriten',
    removeFromFavorites: 'Aus Favoriten entfernen',
    description: 'Beschreibung',
    specifications: 'Spezifikationen',
    sku: 'SKU',
    barcode: 'Strichcode',
    packageDimensions: 'Verpackungsmaße',
    packageSize: 'Versandgröße',
    youMayAlsoLike: 'Das könnte Ihnen auch gefallen',
    productNotFound: 'Produkt nicht gefunden',
    noImage: 'Kein Bild',
    addedToFavorites: 'Zu Favoriten hinzugefügt',
    removedFromFavorites: 'Aus Favoriten entfernt',
    loginRequiredFavorites: 'Bitte melden Sie sich an, um Favoriten zu nutzen.',
    sending: 'Wird gesendet...',
    forgotPasswordSuccess: 'Falls diese E-Mail existiert, haben wir einen Link gesendet. Prüfen Sie Ihren Posteingang.',
    tryAgainLater: 'Fehler. Bitte später erneut versuchen.',
    backToLogin: 'Zurück zur Anmeldung',
    selectedVariant: 'Gewählte Variante',
    selected: 'Gewählt',
    inStock: 'Auf Lager',
    outOfStockLabel: 'Nicht auf Lager',
    adding: 'Wird hinzugefügt...',
    saleEnds: 'Angebot endet',
    recommended: 'Empfohlen',
    reviews: 'Bewertungen',
    collections: 'Kollektionen',
    video: 'Video',
    stockQuantity: 'Lagerbestand',
    productIncludes: 'Dieses Produkt enthält',
    bundleQuantity: 'Menge',
    bundleDiscount: 'Rabatt',
    reviewsCount: '{n} Bewertungen',
    backToProducts: '← Alle Produkte',
    selectSize: 'Größe wählen',
    sizeGuide: 'Größentabelle',
    averageRating: 'Durchschnittliche Bewertung',
    outOfFive: 'von 5',

    checkoutTitle: 'Kasse',
    checkoutSubtitle: 'Füllen Sie Ihre Daten aus und bestellen Sie',
    billingAddress: 'Rechnungsadresse',
    selectSavedAddresses: 'Aus gespeicherten Adressen wählen',
    enterNewAddress: 'Neue Adresse eingeben',
    selectBillingAddress: 'Rechnungsadresse wählen',
    selectAddress: 'Adresse wählen...',
    defaultAddress: 'Standard',
    company: 'Firma',
    address: 'Adresse',
    addressExtra: 'Adresszeile 2',
    city: 'Stadt',
    postalCode: 'PLZ',
    country: 'Land',
    shippingAddress: 'Lieferadresse',
    sameAsBilling: 'Wie Rechnungsadresse',
    shippingSameAsBilling: 'Lieferadresse wie Rechnungsadresse',
    deliveryMethod: 'Versandart',
    selectDelivery: 'Versandart wählen',
    paymentMethod: 'Zahlungsart',
    selectPayment: 'Zahlungsart wählen',
    orderNotes: 'Anmerkungen zur Bestellung',
    placeOrder: 'Bestellung aufgeben',
    cartEmpty: 'Ihr Warenkorb ist leer',
    chooseShipping: 'Versandart wählen',
    choosePayment: 'Zahlungsart wählen',

    loginTitle: 'Anmelden',
    loginSubtitle: 'E-Mail und Passwort eingeben',
    registerSubtitle: 'Konto erstellen',
    toHome: 'Zur Startseite',
    loginError: 'Anmeldefehler',
    loggedOutDueToInactivity: 'Sie wurden wegen Inaktivität (mehr als 2 Stunden) abgemeldet. Bitte melden Sie sich erneut an.',
    or: 'oder',
    noAccount: 'Noch kein Konto?',
    forgotPasswordLink: 'Passwort vergessen',
    forgotPasswordTitle: 'Passwort zurücksetzen',
    forgotPasswordSubtitle: 'E-Mail eingeben – wir senden Ihnen einen Link',
    sendResetLink: 'Link senden',
    resetPasswordTitle: 'Neues Passwort setzen',
    newPassword: 'Neues Passwort',
    resetPassword: 'Passwort zurücksetzen',
    passwordRequirements: 'Passwortanforderungen',
    minChars: 'Mindestens 8 Zeichen',
    oneUpperCase: 'Mindestens ein Großbuchstabe',
    oneLowerCase: 'Mindestens ein Kleinbuchstabe',
    oneNumber: 'Mindestens eine Zahl',
    oneSymbol: 'Mindestens ein Sonderzeichen',
    passwordMismatch: 'Passwörter stimmen nicht überein',

    myOrdersTitle: 'Meine Bestellungen',
    noOrders: 'Sie haben noch keine Bestellungen.',
    orderHistory: 'Ihre Bestellhistorie',
    orderLabel: 'Bestellung',
    time: 'Uhrzeit',
    noOrdersFiltered: 'Keine Bestellungen mit diesem Filter',
    all: 'Alle',
    orderStatusProcessing: 'In Bearbeitung',
    orderStatusShipped: 'Versendet',
    orderStatusDelivered: 'Geliefert',
    orderStatusCancelled: 'Storniert',
    firstOrderHere: 'Ihre erste Bestellung erscheint hier.',
    viewProducts: 'Produkte ansehen',
    orderCount: 'Sie haben {n} Bestellung(en)',
    orderDetails: 'Bestelldetails',
    items: 'Artikel',
    shipping: 'Versand',
    billing: 'Rechnung',
    pending: 'Ausstehend',
    paid: 'Bezahlt',
    refunded: 'Erstattet',

    myAccountTitle: 'Mein Konto',
    profile: 'Profil',
    security: 'Sicherheit',
    addresses: 'Adressen',
    twoFactorAuth: 'Zwei-Faktor-Authentifizierung',

    favoritesTitle: 'Favoriten',
    noFavorites: 'Sie haben noch keine Favoriten.',

    contactTitle: 'Kontakt',
    contactSubtitle: 'Kontaktieren Sie uns',
    subject: 'Betreff',
    message: 'Nachricht',
    send: 'Senden',
    contactIntro: 'Fragen? Füllen Sie das Formular aus – wir melden uns schnellstmöglich.',
    contactNameLabel: 'Name bzw. Firma *',
    contactNamePlaceholder: 'z. B. Max Mustermann oder Firma GmbH',
    contactMessagePlaceholder: 'Schreiben Sie Ihre Nachricht...',
    contactSuccess: 'Nachricht wurde gesendet. Wir melden uns in Kürze.',
    contactError: 'Senden fehlgeschlagen. Bitte später erneut versuchen.',
    selectSubject: 'Thema wählen',
    contactService: 'Kundenservice',
    contactQuality: 'Qualität',
    contactWarranty: 'Garantie',
    followUs: 'Folgen Sie uns',
    shop: 'Shop',
    recommendedLink: 'Empfohlen',
    categories: 'Kategorien',
    information: 'Informationen',
    aboutUs: 'Über uns',
    returns: 'Rückgabe',
    account: 'Konto',
    faq: 'FAQ',
    allRightsReserved: 'Alle Rechte vorbehalten.',
    privacyPolicy: 'Datenschutz',
    termsOfUse: 'Nutzungsbedingungen',
    cookieSettings: 'Cookie-Einstellungen',
    registerError: 'Registrierungsfehler',
    contactPrefix: 'Kontakt',
    contactPrefixAbout: 'Zu',
    salesShort: 'Verkauf',
    serviceShort: 'Service',
    qualityShort: 'Qualität',
    warrantyShort: 'Garantie',

    cookiePolicyTitle: 'Cookie-Richtlinie',

    addressLine2: 'Adresszeile 2',
    selectShippingAddress: 'Lieferadresse wählen',
    saveThisAddress: 'Diese Adresse im Adressbuch speichern',
    noShippingMethods: 'Keine Versandarten. Bitte Administrator kontaktieren.',
    noPaymentMethods: 'Keine Zahlungsmethoden. Bitte Administrator kontaktieren.',
    freeShipping: 'Kostenlos',
    storeCredits: 'Gutschriften',
    storeCreditsAvailable: 'Sie können verwenden',
    useStoreCredits: 'Gutschriften verwenden',
    howMuchCredits: 'Betrag (max. {amount} €)',
    orderSummary: 'Bestellübersicht',
    subtotal: 'Zwischensumme',
    shippingCost: 'Versand',
    taxAmount: 'MwSt.',
    creatingOrder: 'Wird erstellt...',

    stripeOptionCard: 'Karte (Visa, Mastercard, Apple Pay, Google Pay)',
    stripeOptionPayPal: 'PayPal',
    stripeOptionLink: 'Stripe Link',
    stripeOptionIdeal: 'iDEAL',
    stripeOptionGiropay: 'Giropay',
    stripeOptionBancontact: 'Bancontact',

    paymentVerifying: 'Zahlung wird bestätigt...',
    paymentVerifyingHint: 'Bitte warten Sie, wir prüfen den Zahlungsstatus.',
    paymentSuccessTitle: 'Zahlung erfolgreich',
    paymentSuccessText: 'Ihre Bestellung wird bearbeitet. Sie werden in Kürze zur Bestellseite weitergeleitet.',
    redirectingToOrder: 'Weiterleitung zur Bestellung...',
    paymentConfirmFailed: 'Zahlungsbestätigung fehlgeschlagen',
    paymentConfirmErrorText: 'Bei der Bestätigung der Zahlung ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Support.',
    checkConsoleHint: 'Weitere Informationen finden Sie in der Browser-Konsole (F12).',

    orderNotFound: 'Bestellung nicht gefunden',
    orderNotFoundText: 'Die gesuchte Bestellung existiert nicht oder wurde entfernt.',
    backToOrders: 'Zurück zu Bestellungen',
    orderStatusLabel: 'Bestellstatus',
    paymentStatusLabel: 'Zahlungsstatus',
    orderInfo: 'Bestellinformationen',
    orderItems: 'Bestellte Artikel',
    notSpecified: 'Nicht angegeben',
    returnSuccess: 'Rückgabeanfrage erfolgreich erstellt',
    returnError: 'Fehler beim Erstellen der Rückgabeanfrage',
    failed: 'Fehlgeschlagen',
    returnRequested: 'Angefordert',
    returnApproved: 'Genehmigt',
    returnRejected: 'Abgelehnt',
    returnReceived: 'Erhalten',
    accountSubtitle: 'Verwalten Sie Ihre Kontoeinstellungen und Informationen',
    passwordTab: 'Passwort',
    profileInfo: 'Profilinformationen',
    emailCannotChange: 'E-Mail kann nicht geändert werden',
    profileUpdated: 'Profil erfolgreich aktualisiert',
    profileUpdateError: 'Fehler beim Aktualisieren des Profils',
    passwordChanged: 'Passwort erfolgreich geändert',
    passwordChangeError: 'Fehler beim Passwort ändern',
    creditsTab: 'Gutschriften',
    favoritesTabShort: 'Favoriten',
    favoritesSubtitle: 'Ihre gespeicherten Artikel',
    emptyFavoritesText: 'Ihre Favoritenliste ist leer',
    emptyFavoritesHint: 'Fügen Sie Artikel zu Favoriten hinzu, um sie später leichter zu finden.',
    errorRemovingFavorite: 'Fehler beim Entfernen',
    favoritesCount: '{n} Artikel in Ihrer Liste',
    cookiePolicyLastUpdated: 'Zuletzt aktualisiert',
    saveChanges: 'Änderungen speichern',
    saving: 'Wird gespeichert...',
    currentPassword: 'Aktuelles Passwort',
    changePassword: 'Passwort ändern',
    changingPassword: 'Wird geändert...',
    accountInfo: 'Kontoinformationen',
    accountCreated: 'Konto erstellt',
    lastLogin: 'Letzte Anmeldung',
    never: 'Nie',
    emailVerification: 'E-Mail-Bestätigung',
    verified: 'Bestätigt',
    notVerified: 'Nicht bestätigt',
    sendVerificationEmail: 'Bestätigungs-E-Mail senden',
    verificationEmailSent: 'Bestätigungs-E-Mail gesendet. Bitte prüfen Sie Ihren Posteingang (und Spam).',
    verifyEmailHint: 'Falls Ihre E-Mail nicht bestätigt ist, klicken Sie auf den Button – Sie erhalten einen Bestätigungslink.',
    verifyEmailTitle: 'E-Mail bestätigen',
    emailVerifiedSuccess: 'E-Mail erfolgreich bestätigt. Sie können zu Ihrem Konto zurückkehren.',
    verificationLinkExpired: 'Link abgelaufen oder bereits verwendet. Fordern Sie in Mein Konto eine neue Bestätigungs-E-Mail an.',
    backToAccount: 'Zurück zum Konto',

    twoFactorTitle: 'Zwei-Faktor-Authentifizierung',
    twoFactorEnabled: '2FA aktiv',
    twoFactorProtected: 'Ihr Konto ist durch Zwei-Faktor-Authentifizierung geschützt.',
    disable2FA: '2FA deaktivieren',
    regenerateBackupCodes: 'Neue Backup-Codes erstellen',
    setup2FA: '2FA einrichten',
    twoFactorStep1: '1. Scannen Sie den QR-Code mit einer Authenticator-App (z. B. Google Authenticator, Authy):',
    orEnterManually: 'Oder manuell eingeben:',
    twoFactorStep2: '2. Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App ein:',
    verifying: 'Wird überprüft...',
    backupCodesTitle: 'Backup-Codes',
    backupCodesWarning: 'WICHTIG: Bewahren Sie diese Backup-Codes an einem sicheren Ort auf. Sie werden nur einmal angezeigt!',
    done: 'Fertig',
    twoFactorDisabled: '2FA deaktiviert',
    twoFactorDisabledDesc: 'Aktivieren Sie die Zwei-Faktor-Authentifizierung für mehr Kontosicherheit.',
    how2FAWorks: 'Wie funktioniert 2FA?',
    twoFAList1: 'Beim Anmelden müssen Sie zusätzlich zum Passwort einen Code aus Ihrer Authenticator-App eingeben',
    twoFAList2: 'Sie können Google Authenticator, Authy oder eine andere TOTP-App verwenden',
    twoFAList3: 'Sie erhalten 10 Backup-Codes für den Fall, dass Sie keine Zugriff auf Ihre Authenticator-App haben',
    enable2FA: '2FA aktivieren',
    settingUp: 'Wird eingerichtet...',
    twoFADisabledSuccess: '2FA deaktiviert',
    errorDisabling2FA: 'Fehler beim Deaktivieren von 2FA',
    backupCodesUpdated: 'Backup-Codes aktualisiert',
    errorRegeneratingBackup: 'Fehler beim Erstellen der Backup-Codes',
    enterPasswordToDisable2FA: 'Geben Sie Ihr Passwort ein, um 2FA zu deaktivieren:',
    enterPasswordForBackupCodes: 'Geben Sie Ihr Passwort ein, um neue Backup-Codes zu erstellen:',
    invalidCode: 'Ungültiger Code',

    admin_dashboard: 'Übersicht',
    admin_orders: 'Bestellungen',
    admin_assortment: 'Sortiment',
    admin_products: 'Produkte',
    admin_categories: 'Kategorien',
    admin_users: 'Benutzer',
    admin_finance: 'Finanzen',
    admin_invoices: 'Rechnungen',
    admin_credit_invoices: 'Gutschriften',
    admin_store_credits: 'Store Credits',
    admin_promotions_nav: 'Aktionen',
    admin_promotions: 'Aktionen',
    admin_coupons: 'Gutscheine',
    admin_gift_cards: 'Geschenkkarten',
    admin_loyalty: 'Treue',
    admin_content: 'Inhalte',
    admin_header_menu: 'Header-Menülinks',
    admin_home_page: 'Startseite',
    admin_pages: 'Seiten',
    admin_footer_links: 'Footer-Links',
    admin_settings: 'Einstellungen',
    admin_store: 'Shop',
    admin_shipping: 'Versand',
    admin_shipping_methods: 'Versandarten',
    admin_courier_integrations: 'Kurier-Integrationen (Unisend)',
    admin_finance_reports: 'Finanzen',
    admin_payment_methods: 'Zahlungsmethoden',
    admin_invoice_settings: 'Rechnungseinstellungen',
    admin_email_automation: 'E-Mail',
    admin_smtp: 'SMTP-Einstellungen',
    admin_marketplace: 'Marketplace',
    admin_backups: 'Backup',
    admin_errors: 'Fehler',
    admin_quick_actions: 'Schnellaktionen',
    admin_new_product: 'Neues Produkt',
    admin_search_placeholder: 'Suchen... (⌘K)',
    admin_search_placeholder_short: '⌘K',
    admin_back_to_store: 'Zurück zum Shop',
    admin_collapse_sidebar: 'Einklappen',
    admin_expand_sidebar: 'Aufklappen',
    admin_search_functions: 'Funktionen suchen... (Esc schließen)',
    admin_search_no_results: 'Nichts gefunden für',

    // Admin – Zahlungsmethoden (Einstellungen → Zahlungsmethoden)
    paymentMethodsTitle: 'Zahlungsmethoden',
    paymentMethodsSubtitle: 'Zahlungsmethoden und ihre Einstellungen konfigurieren',
    paymentMethodActive: 'Aktiv',
    paymentMethodInactive: 'Inaktiv',
    paymentMethodTestMode: 'Testmodus',
    paymentMethodEdit: 'Bearbeiten',
    paymentMethodEditTitle: 'Bearbeiten: {name}',
    paymentMethodEnable: 'Zahlungsmethode aktivieren',
    paymentMethodTestModeLabel: 'Testmodus',
    paymentMethodSortOrder: 'Sortierreihenfolge',
    paymentMethodConfiguration: 'Konfiguration',
    paymentMethodEnterPlaceholder: '{label} eingeben...',
    paymentMethodSuccessUpdate: 'Zahlungsmethode erfolgreich aktualisiert',
    paymentMethodErrorUpdate: 'Fehler beim Aktualisieren der Zahlungsmethode',
    paymentMethodNameLt: 'Name (Litauisch)',
    paymentMethodNameEn: 'Name (Englisch)',
    paymentMethodNameDe: 'Name (Deutsch)',
    paymentMethodNameHint: 'Legen Sie den Anzeigenamen pro Sprache fest. Wenn leer, wird der Standard verwendet.',
    paymentMethodDisplayMode: 'Anzeige im Shop',
    paymentMethodDisplayName: 'Nur Name',
    paymentMethodDisplayImage: 'Nur Bild',
    paymentMethodDisplayNameAndImage: 'Name und Bild',
    paymentMethodImageUpload: 'Bild',
    paymentMethodImageSelect: 'Vom Computer hochladen',
    paymentMethodImageRemove: 'Bild entfernen',
    paymentMethodImageInvalid: 'Bitte wählen Sie eine Bilddatei (JPG, PNG, GIF, WebP)',
    paymentMethodImageUploaded: 'Bild hochgeladen',
    paymentMethodImageUploadError: 'Bild konnte nicht hochgeladen werden',
    uploading: 'Wird hochgeladen...',
    paymentConfigTestSecretKey: 'Test-Geheimschlüssel',
    paymentConfigTestPublishableKey: 'Test-Veröffentlichungsschlüssel',
    paymentConfigLiveSecretKey: 'Live-Geheimschlüssel',
    paymentConfigLivePublishableKey: 'Live-Veröffentlichungsschlüssel',
    paymentConfigClientId: 'Client-ID',
    paymentConfigClientSecret: 'Geheimschlüssel',
    paymentConfigSandboxMode: 'Sandbox-Modus',
    paymentConfigMerchantId: 'Händler-ID',
    paymentConfigPrivateKey: 'Privater Schlüssel',
    paymentConfigBankUrl: 'Bank-URL',
    stripeQuickMethodsTitle: 'Zusätzliche Methoden (Karte, Apple Pay, Google Pay)',
    stripeQuickMethodsHint: 'Anzeigename und Bild auf der Checkout-Seite. Wenn leer, werden Standardwerte verwendet.',
    stripeQuickCardTitle: 'Karte',
    stripeQuickApplePayTitle: 'Apple Pay',
    stripeQuickGooglePayTitle: 'Google Pay',

    paymentConfigBankAccountsHint: 'Geben Sie ein oder mehrere Bankkonten an. Kunden sehen alle und können auf jedes überweisen.',
    paymentConfigAddBankAccount: 'Bankkonto hinzufügen',
    paymentConfigIban: 'IBAN',
    paymentConfigBankName: 'Bank',
    paymentConfigBankNamePlaceholder: 'z. B. Swedbank',
    paymentConfigCompanyName: 'Empfänger (Firma / Name)',
    paymentConfigCompanyNamePlaceholder: 'z. B. Firma GmbH',
    paymentConfigRemoveAccount: 'Konto entfernen',
    paymentConfigReferencePrefix: 'Verwendungszweck-Präfix (optional)',
    paymentConfigReferencePrefixPlaceholder: 'z. B. ORD oder leer lassen',
    paymentConfigInstructionsLt: 'Zusätzliche Anweisungen (Litauisch)',
    paymentConfigInstructionsEn: 'Zusätzliche Anweisungen (Englisch)',
    paymentConfigInstructionsDe: 'Zusätzliche Anweisungen (Deutsch)',
    paymentConfigInstructionsPlaceholder: 'Text unter den Bankdaten',
    bankTransferDefaultInstructionsLt: 'Sumą perveskite į nurodytą sąskaitą. Paskirtyje nurodykite užsakymo numerį.',
    bankTransferDefaultInstructionsEn: 'Transfer the amount to the account below. In the reference, indicate the order number.',
    bankTransferDefaultInstructionsDe: 'Überweisen Sie den Betrag auf das angegebene Konto. Geben Sie im Verwendungszweck die Bestellnummer an.',
    bankAccountLabel: 'Konto',
    paymentOptionCard: 'Karte',
    paymentOptionApplePay: 'Apple Pay',
    paymentOptionGooglePay: 'Google Pay',

    cookieBannerText: 'Wir verwenden Cookies, damit die Website funktioniert, benutzerfreundlicher ist und wir den Traffic analysieren können. Mehr –',
    cookiePolicyInLink: 'Cookie-Richtlinie',
    acceptAll: 'Alle akzeptieren',
    cookieSettingsBtn: 'Einstellungen',
    rejectOptional: 'Optionale ablehnen',
    cookieSettingsIntro: 'Wählen Sie, welche Cookies wir verwenden dürfen:',
    necessaryCookies: 'Erforderlich – für die Funktion der Website (z. B. Sitzung, Warenkorb). Sie können nicht deaktiviert werden.',
    analyticsCookies: 'Analytik – hilft zu verstehen, wie Besucher die Website nutzen.',
    marketingCookies: 'Marketing – für personalisierte Inhalte und Werbung.',
    saveChoice: 'Auswahl speichern',

    accessibilitySettingsTitle: 'Barrierefreiheit',
    accessibilitySettingsDesc: 'Passen Sie die Website an Ihre Bedürfnisse an. Einstellungen werden im Browser gespeichert.',
    closeAccessibility: 'Barrierefreiheit schließen',
    textSize: 'Schriftgröße',
    normalSize: 'Normal',
    largerSize: 'Größer',
    evenLargerSize: 'Noch größer',
    contrast: 'Kontrast',
    highContrast: 'Hoher Kontrast',
    reduceMotion: 'Bewegung reduzieren',
    showFocusOutline: 'Fokus immer anzeigen',
    underlineLinks: 'Links unterstreichen',
    resetSettings: 'Einstellungen zurücksetzen',

    cartSummary: 'Warenkorbübersicht',
    withoutVAT: 'zzgl. MwSt.',

    orderNotesLabel: 'Anmerkungen',
    invoiceTitle: 'Rechnung',
    invoiceNumber: 'Rechnungsnummer',
    issueDate: 'Rechnungsdatum',
    dueDate: 'Fälligkeitsdatum',
    draft: 'Entwurf',
    downloadPdfInvoice: 'PDF-Rechnung herunterladen',
    loginRequiredInvoice: 'Bitte melden Sie sich an, um die Rechnung herunterzuladen.',
    errorDownloadingPdf: 'PDF-Download fehlgeschlagen',
    productReturns: 'Warenrückgabe',
    yourReturnRequests: 'Ihre Rückgabeanfragen',
    returnNumberLabel: 'Rückgabenummer',
    reasonLabel: 'Grund',
    refundAmount: 'Rückerstattungsbetrag',
    trackingNumber: 'Sendungsnummer',
    cancelReturnConfirm: 'Möchten Sie diese Rückgabeanfrage wirklich stornieren?',
    confirmCancelReturn: 'Stornierung bestätigen',
    returnCancelled: 'Rückgabeanfrage storniert',
    errorCancellingReturn: 'Fehler beim Stornieren',
    cancelReturn: 'Rückgabe stornieren',
    initiateReturn: 'Warenrückgabe starten',
    newReturnRequest: 'Neue Rückgabeanfrage',
    selectItemsForReturn: 'Artikel für Rückgabe auswählen',
    selectAtLeastOneItem: 'Wählen Sie mindestens einen Artikel für die Rückgabe',
    returnReasonRequired: 'Bitte geben Sie den Rückgabegrund an',
    selectReasonPlaceholder: 'Grund wählen...',
    returnReasonLabel: 'Rückgabegrund *',
    additionalNotes: 'Zusätzliche Anmerkungen',
    returnNotesPlaceholder: 'Zusätzliche Informationen zur Rückgabe...',
    submitReturnRequest: 'Rückgabeanfrage absenden',
    reasonDefective: 'Defektes Produkt',
    reasonWrongItem: 'Falsches Produkt',
    reasonNotAsDescribed: 'Entspricht nicht der Beschreibung',
    reasonDamaged: 'Bei Lieferung beschädigt',
    reasonChangedMind: 'Meinung geändert',
    reasonOther: 'Sonstiger Grund',
    taxLabel21: 'MwSt. (21%)',

    storeCreditsTitle: 'Gutschriften',
    totalBalance: 'Gesamtguthaben',
    noStoreCredits: 'Sie haben keine Gutschriften.',
    creditsInfo: 'Gutschriften können bei Rückgaben oder als Entschädigung gewährt werden.',
    creditsHistory: 'Gutschrifthistorie',
    balance: 'Guthaben',
    validUntil: 'Gültig bis',
    creditSourceRefund: 'Rückerstattung',
    creditSourceManual: 'Manuell',
    creditSourcePromotion: 'Aktion',

    myAddresses: 'Meine Adressen',
    addNewAddress: 'Neue Adresse hinzufügen',
    editAddress: 'Adresse bearbeiten',
    addressType: 'Adresstyp',
    bothAddressTypes: 'Beides',
    confirmDeleteAddress: 'Möchten Sie diese Adresse wirklich entfernen?',
    addressAdded: 'Adresse erfolgreich hinzugefügt',
    addressUpdated: 'Adresse erfolgreich aktualisiert',
    addressRemoved: 'Adresse erfolgreich entfernt',
    defaultAddressSet: 'Standardadresse festgelegt',
    errorAddingAddress: 'Fehler beim Hinzufügen der Adresse',
    errorUpdatingAddress: 'Fehler beim Aktualisieren der Adresse',
    errorRemovingAddress: 'Fehler beim Entfernen der Adresse',
    errorSettingDefault: 'Fehler beim Festlegen der Standardadresse',
    setAsDefaultAddress: 'Als Standardadresse festlegen',
    addAddress: 'Adresse hinzufügen',
    setAsDefault: 'Als Standard festlegen',
    bothAddressesLabel: 'Liefer- und Rechnungsadresse',
    noAddressesMessage: 'Sie haben keine gespeicherten Adressen. Fügen Sie Ihre erste Adresse hinzu.',

    bankTransfer: 'Banküberweisung',
    bankTransferInstructions: 'Zahlungsanweisung',
    paymentReference: 'Verwendungszweck',
    iban: 'IBAN',
    bankName: 'Bank',
    companyName: 'Empfänger',
    amountToPay: 'Zu zahlender Betrag',
  },
};

const STORAGE_KEY = 'language';
const DEFAULT_LANG = 'lt';

/** Grąžina išsaugotą kalbą arba null, jei dar niekada nepasirinkta (skirta auto-detect). */
export function getStoredLanguage() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && (stored === 'lt' || stored === 'en' || stored === 'de')) return stored;
  } catch (e) {}
  return null;
}

/** Grąžina kalbą rodymui (niekada null – naudoti pradinei būsenai). */
export function getStoredLanguageOrDefault() {
  return getStoredLanguage() || DEFAULT_LANG;
}

export function setStoredLanguage(lang) {
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch (e) {}
}
